module.exports = __webpack_public_path__ + "static/img/c2-1.eddd241.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/c2-1.png
// module id = 709
// module chunks = 1